module.exports = __webpack_public_path__ + "settings-big.png?bb25babc3c4c4bdf19272c8a121ed242";